<template>
  <div v-if="authStore.showAuthGate" class="auth-gate-open">
    <div class="auth-gate">
      <div class="auth-gate__backdrop" @click="authStore.dismissAuthGate"></div>

      <div class="auth-gate__quote">
        <p>"Millionaires don't use astrology, billionaires do."</p>
        <cite>&mdash; J.P. Morgan</cite>
      </div>

      <div class="auth-gate__panel">
        <button class="auth-gate__close" @click="authStore.dismissAuthGate">&times;</button>

        <div v-if="authStore.error" class="auth-gate__alert">
          {{ authStore.error }}
        </div>

        <div class="auth-gate__tabs">
          <button
            :class="['auth-gate__tab', { 'is-active': mode === 'login' }]"
            @click="mode = 'login'"
          >Sign In</button>
          <button
            :class="['auth-gate__tab', { 'is-active': mode === 'register' }]"
            @click="mode = 'register'"
          >Create Account</button>
        </div>

        <form @submit.prevent="handleSubmit" class="auth-gate__form">
          <button type="button" class="auth-gate__google-btn" @click="authStore.loginWithGoogle" :disabled="authStore.isLoading">
            <svg viewBox="0 0 24 24" width="18" height="18">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
            </svg>
            {{ authStore.isLoading ? 'Please wait...' : 'Continue with Google' }}
          </button>
          <div class="auth-gate__divider"><span>or</span></div>
          <div class="auth-gate__field">
            <span>Email</span>
            <input
              v-model="email"
              type="email"
              placeholder="your@email.com"
              required
              autocomplete="email"
            />
          </div>
          <div class="auth-gate__field">
            <span>Password</span>
            <input
              v-model="password"
              type="password"
              placeholder="Enter your password"
              required
              autocomplete="current-password"
            />
          </div>
          <button type="submit" class="auth-gate__submit" :disabled="authStore.isLoading">
            {{ authStore.isLoading ? 'Please wait...' : (mode === 'login' ? 'Sign In' : 'Create Account') }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useAuthStore } from '../stores/auth';

const authStore = useAuthStore();
const mode = ref('login');
const email = ref('');
const password = ref('');

const handleSubmit = async () => {
  if (mode.value === 'login') {
    await authStore.login(email.value, password.value);
  } else {
    await authStore.register(email.value, password.value);
  }
};
</script>

<style scoped>
.auth-gate__google-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.65rem 1rem;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: #fff;
  color: #1f2937;
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  font-family: inherit;
}

.auth-gate__google-btn:hover {
  background: #f9fafb;
  border-color: #d1d5db;
}

.auth-gate__google-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.auth-gate__divider {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin: 0.75rem 0;
  color: var(--text-dim);
  font-size: 0.75rem;
}

.auth-gate__divider::before,
.auth-gate__divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: var(--border-color);
}
</style>
